// extracted by mini-css-extract-plugin
export default {"inner":"PvMPI","icon":"Xh1sY","main":"tVHJP","title":"n3oqs","text":"k7o8P","progress":"I6WDb","progressTrack":"PQ3AT"};